// eslint-disable-next-line import/prefer-default-export
export const copywriting = {
  NOTIFY_TEAM_CHANGES: "Suggest change",
  SPECIALIST_ROLE: "Agile Specialist Role",
  EDIT_ALLOCATIONS: "Edit allocations",
};
